import React from 'react';

import {AutocompleteProps} from "@mui/material/Autocomplete/Autocomplete";
import Autocomplete from "@mui/material/Autocomplete";
import SelectMultiSearchVirtualize from './SelectMultiSearchVirtal'

const AutocompleteMultiWrapperSearch = (props: AutocompleteProps<any, any, any, any, any>) => {
    if (props.options?.length > 100) {
        return <SelectMultiSearchVirtualize {...props as any}/>
    }
    return (
        <Autocomplete  {...props}/>
    );
};

export default AutocompleteMultiWrapperSearch;